import userAgreement from "@components/userAgreement/userAgreement.vue";
export default {
  components: {
    userAgreement: userAgreement
  },
  name: "register",
  data: function () {
    //手机号验证方法
    var validatePhone = (rule, value, callback) => {
      if (value == "") {
        callback(new Error(this.$t("register.enterPhoneNum")));
      } else if (
        !/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[0-9])\d{8}$/.test(
          value
        )
      ) {
        callback(new Error(this.$t("register.worngPhoneNum")));
      } else {
        this.$http
          .get(globalProvider.serviceUrl("ea/tt/ck/mb/{value}"), {
            params: { value: value },
            headers: { ttoken: this.captcha_token }
          })
          .then(data => {
            if (data.body.code == resultCode.Success) {
              if (data.body.data == true) {
                callback(new Error(this.$t("register.phoneRegistered")));
              } else {
                callback();
              }
            }
          });
      }
    };
    //邮箱验证方法
    var validateEmail = (rule, value, callback) => {
      if (value == "") {
        callback(new Error(this.$t("register.enterEmail")));
      } else if (
        !this.$common.validEmail(value)
      ) {
        callback(new Error(this.$t("register.worngEmail")));
      } else {
        this.$http
          .get(globalProvider.serviceUrl("ea/tt/ck/em/{value}"), {
            params: { value: value },
            headers: { ttoken: this.captcha_token }
          })
          .then(data => {
            if (data.body.code == resultCode.Success) {
              if (data.body.data == true) {
                callback(new Error(this.$t("register.emailRegistered")));
              } else {
                callback();
              }
            }
          });
      }
    };
    //账号验证方法
    var validateAccount = (rule, value, callback) => {
      if (value == "") {
        callback(new Error(this.$t("register.enterAccount")));
        this.phoneReg_form2_right.account = false;
      } else {
        let pattern = /^[A-Za-z]{1}[A-Za-z0-9_]{5,25}$/;
        if (pattern.test(value)) {
          this.$http
            .get(globalProvider.serviceUrl("ea/tt/c/ac/{value}"), {
              params: { value: value },
              headers: { Authorization: "ata-token " + this.ttoken }
            })
            .then(data => {
              if (data.body.code == 10) {
                if (data.body.data) {
                  this.phoneReg_form2_right.account = false;
                  callback(new Error(this.$t("register.accRegistered")));
                } else {
                  this.phoneReg_form2_right.account = true;
                  callback();
                }
              }
            });
        } else {
          this.phoneReg_form2_right.account = false;
          callback(new Error(this.$t("register.enterAccount")));
        }
      }
    };
    //第一次密码验证方法
    var validatePass = (rule, value, callback) => {
      if (value == "") {
        callback(new Error(this.$t("register.pwdlimit")));
        this.phoneReg_form2_right.pwd = false;
      } else if (!/^[^\s]{6,26}$/.test(value)) {
        callback(new Error(this.$t("register.pwdlimit")));
        this.phoneReg_form2_right.pwd = false;
      } else {
        if (this.phoneReg_form2.c_pwd != "") {
          this.$refs.phoneReg_form2.validateField("c_pwd");
        }
        callback();
        this.phoneReg_form2_right.pwd = true;
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value == "") {
        callback(new Error(this.$t("register.confirmPwdAgain")));
        this.phoneReg_form2_right.c_pwd = false;
      } else if (value != this.phoneReg_form2.pwd) {
        callback(new Error(this.$t("register.confirmPwdWrong")));
        this.phoneReg_form2_right.c_pwd = false;
      } else {
        callback();
        this.phoneReg_form2_right.c_pwd = true;
      }
    };
    var validateCt = (rule, value, callback) => {
      if (value == "") {
        callback(new Error(this.$t("register.wrongId")));
        this.phoneReg_form2_right.ct = false;
      } else if (this.error_msg == "EA_NACIA_CI_03") {
        callback(new Error(getErrorMessage(this.error_msg)));
        this.error_msg = "";
        this.phoneReg_form2_right.ct = false;
      } else if (this.phoneReg_form2.t_ct == "") {
        callback(new Error(this.$t("register.selectIdType")));
        this.phoneReg_form2_right.ct = false;
      } else if (
        this.getStringSite(this.CertTypes, this.phoneReg_form2.t_ct) == 0
      ) {
        if (value.length == 18) {
          if (this.$common.validateChinaCt(value)) {
            this.$http
              .get(globalProvider.serviceUrl("ea/tt/c/ci/{type}/{value}"), {
                params: { value: value, type: this.phoneReg_form2.t_ct },
                headers: { Authorization: "ata-token " + this.ttoken }
              })
              .then(data => {
                if (data.body.code == 10) {
                  if (data.body.data) {
                    callback(new Error(this.$t("register.idRegistered")));
                    this.phoneReg_form2_right.ct = false;
                  } else {
                    callback();
                    this.phoneReg_form2_right.ct = true;
                  }
                }
              });
          } else {
            //暂不判断最后一个校验码
            callback(new Error(this.$t("register.wrongId")));
            this.phoneReg_form2_right.ct = false;
          }
        } else {
          callback(new Error(this.$t("register.wrongId")));
          this.phoneReg_form2_right.ct = false;
        }
      } else if (
        this.phoneReg_form2.t_ct == "32a4ea6ecd488590c74d875117219253"
      ) {
        //验证香港来往内地
        if (this.$common.validateHongKongPass(value)) {
          this.$http
            .get(globalProvider.serviceUrl("ea/tt/c/ci/{type}/{value}"), {
              params: { value: value, type: this.phoneReg_form2.t_ct },
              headers: { Authorization: "ata-token " + this.ttoken }
            })
            .then(data => {
              if (data.body.code == 10) {
                if (data.body.data) {
                  callback(new Error(this.$t("register.idRegistered")));
                  this.phoneReg_form2_right.ct = false;
                } else {
                  callback();
                  this.phoneReg_form2_right.ct = true;
                }
              }
            });
        } else {
          //暂不判断最后一个校验码
          callback(new Error(this.$t("register.wrongId")));
          this.phoneReg_form2_right.ct = false;
        }
      } else if (
        this.phoneReg_form2.t_ct == "3c266df9007037d94c632875e066f488"
      ) {
        //验证台湾居民来往大陆
        if (this.$common.validateTaiWanPass(value)) {
          this.$http
            .get(globalProvider.serviceUrl("ea/tt/c/ci/{type}/{value}"), {
              params: { value: value, type: this.phoneReg_form2.t_ct },
              headers: { Authorization: "ata-token " + this.ttoken }
            })
            .then(data => {
              if (data.body.code == 10) {
                if (data.body.data) {
                  callback(new Error(this.$t("register.idRegistered")));
                  this.phoneReg_form2_right.ct = false;
                } else {
                  callback();
                  this.phoneReg_form2_right.ct = true;
                }
              }
            });
        } else {
          //暂不判断最后一个校验码
          callback(new Error(this.$t("register.wrongId")));
          this.phoneReg_form2_right.ct = false;
        }
      } else if (
        this.getStringSite(this.CertTypes, this.phoneReg_form2.t_ct) != 0
      ) {
        this.$http
          .get(globalProvider.serviceUrl("ea/tt/c/ci/{tct}/{value}"), {
            params: { value: value, tct: this.phoneReg_form2.t_ct },
            headers: { Authorization: "ata-token " + this.ttoken }
          })
          .then(data => {
            if (data.body.code == 10) {
              if (data.body.data) {
                callback(new Error(this.$t("register.idRegistered")));
                this.phoneReg_form2_right.ct = false;
              } else {
                callback();
                this.phoneReg_form2_right.ct = true;
              }
            } else {
              this.$alert(data.body.msg, this.$t("common.tip"), {
                confirmButtonText: this.$t("common.confirm"),
                callback: function (action) { }
              });
            }
          });
      }
    };
    var validatePhoneImgCaptcha = (rule, value, callback) => {
      if (value == "") {
        callback(new Error(this.$t("common.enterCode")));
      } else if (this.error_msg == "EA_MAA_CDC_02") {
        callback(new Error(getErrorMessage(this.error_msg)));
        this.error_msg = "";
      } else {
        callback();
      }
    };
    var validateEmailImgCaptcha = (rule, value, callback) => {
      if (value == "") {
        callback(this.$t("common.enterCode"));
      }
      if (this.error_msg == "EA_EAA_CDC_02") {
        callback(new Error(getErrorMessage(this.error_msg)));
        this.error_msg = "";
      } else {
        callback();
      }
    };
    var validatePhoneCaptcha = (rule, value, callback) => {
      if (this.error_msg == "EA_MAA_SUAI_02") {
        callback(new Error(getErrorMessage(this.error_msg)));
        this.error_msg = "";
      } else {
        callback();
      }
    };
    var validateEmailCaptcha = (rule, value, callback) => {
      if (this.error_msg == "EA_EAA_SUAI_02") {
        callback(new Error(getErrorMessage(this.error_msg)));
        this.error_msg = "";
      } else {
        callback();
      }
    };
    var validateName = (rule, value, callback) => {
      if (value == "") {
        callback(this.$t("register.enterName"));
        this.phoneReg_form2_right.name = false;
      } else {
        callback();
        this.phoneReg_form2_right.name = true;
      }
    };
    return {
      offsetHeight: document.body.offsetHeight,
      user_agreement_box: false,
      domain: "",
      CertTypes: "",
      captcha_token: "",
      useInfoDisable: false,
      checked: true,
      ttoken: "",
      captchaUrl: "",
      Reg_way: "1",
      error_msg: "",
      error_display: false,
      error_message: "",
      pb_disabled: false,
      emailSubmitDisabled: false,
      phoneSubmitDisabled: false,
      pb_show: this.$t("message.getVerificationCode"),
      email_pb_disabled: false,
      email_pb_show: this.$t("message.getVerificationCode"),
      phoneReg_step: 1,
      phoneReg_form: {
        phone: "",
        phone_img_captcha: "",
        phone_captcha: ""
      },
      phoneReg_form_right: {
        phone: false,
        phone_img_captcha: false,
        phone_captcha: false
      },
      phoneReg_form_rule: {
        phone: [{ required: true, validator: validatePhone, trigger: "blur" }],
        phone_img_captcha: [
          {
            required: false,
            validator: validatePhoneImgCaptcha,
            trigger: "change"
          }
        ],
        phone_captcha: [
          { required: true, message: this.$t("common.enterCode"), trigger: "change" },
          { validator: validatePhoneCaptcha, trigger: "change" }
        ]
      },
      emailReg_form: {
        email: "",
        email_img_captcha: "",
        email_captcha: ""
      },
      emailReg_form_right: {
        email: false,
        email_img_captcha: false,
        email_captcha: false
      },
      emailReg_form_rule: {
        email: [{ required: true, validator: validateEmail, trigger: "blur" }],
        email_img_captcha: [
          {
            required: false,
            validator: validateEmailImgCaptcha,
            trigger: "change"
          }
        ],
        email_captcha: [
          { required: true, message: this.$t("common.enterCode"), trigger: "change" },
          { validator: validateEmailCaptcha, trigger: "change" }
        ]
      },
      phoneReg_form2: {
        //                    account: '',
        pwd: "",
        c_pwd: "",
        name: "",
        t_ct: "",
        ct: ""
      },
      phoneReg_form2_rule: {
        //                    account: [
        //                        {required: true, validator: validateAccount, trigger: 'blur'},
        //                    ],
        pwd: [{ required: true, validator: validatePass, trigger: "blur" }],
        c_pwd: [{ required: true, validator: validatePass2, trigger: "blur" }],
        name: [{ required: true, validator: validateName, trigger: "change" }],
        t_ct: [
          { required: true, message: this.$t("register.selectIdType"), trigger: "change" }
        ],
        ct: [{ required: true, validator: validateCt, trigger: "blur" }]
      },
      phoneReg_form2_right: {
        account: false,
        pwd: false,
        c_pwd: false,
        name: false,
        t_ct: false,
        ct: false
      }
    };
  },
  //第一次获取验证码
  created: function () {
    // this.phoneReg_step = 3;
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.$store.commit("setHeaderState", "100");
    this.get_captcha_token();
    this.domain = this.$store.state.examInfo.currentExamInfo.domain;
    this.batchCode = this.$store.state.examInfo.currentExamInfo.batchCode;
    this.Reg_way = this.domain == 'itp' ? '2' : '1';
  },
  methods: {
    restrictChar() {
      this.phoneReg_form2.name = this.phoneReg_form2.name.replace(/[！@#￥~%&*?!^\d+$]/g, "");
    },
    handleResize(event) {
      this.offsetHeight = document.body.offsetHeight - 100;
    },

    onUserAgreement(val) {
      this.user_agreement_box = val[0];
      this.checked = val[1];
    },
    //更改注册方法
    change_re_way: function () {
      if (this.$refs.phoneReg_form != null)
        this.$refs.phoneReg_form.resetFields();
      if (this.$refs.emailReg_form != null)
        this.$refs.emailReg_form.resetFields();
      this.error_display = false;
      this.get_captcha_token();
    },
    //获取临时token
    get_captcha_token: function () {
      this.$http.get(globalProvider.serviceUrl("ea/tt")).then(data => {
        if (data.body.code == 10) {
          this.captcha_token = data.body.data;
          this.captchaUrl = serviceUrl + "ea/tt/vc/" + this.captcha_token;
        } else {
          this.$alert(data.body.msg, this.$t("common.tip"), {
            confirmButtonText: this.$t("common.confirm"),
            callback: function (action) {
              console.log("OK");
            }
          });
        }
      });
    },
    //仅仅获取临时token
    set_captcha_token: function () {
      this.$http.get(globalProvider.serviceUrl("ea/tt")).then(data => {
        if (data.body.code == resultCode.Success) {
          this.captcha_token = data.body.data;
        } else {
          this.$alert(data.body.msg, this.$t("common.tip"), {
            confirmButtonText: this.$t("common.confirm"),
            callback: function (action) {
              console.log("OK");
            }
          });
        }
      });
    },
    getStringSite: function (list, string) {
      let num = -1;
      list.forEach((item, index) => {
        if (item.value == string) {
          num = index;
        }
      });
      return num;
    },
    //获取手机动态码
    onGetPhoneCaptcha: function () {
      this.$refs.phoneReg_form.validateField("phone", valid => {
        if (valid == "") {
          this.$refs.phoneReg_form.validateField("phone_img_captcha", valid => {
            if (valid == "") {
              this.$http
                .get(
                  globalProvider.serviceUrl("ea/tt/g/mrdc/ts/") +
                  escape(this.phoneReg_form.phone),
                  {
                    headers: {
                      ttoken: this.captcha_token
                    }
                  }
                )
                .then(data => {
                  if (data.body.code == resultCode.Success) {
                    if (data.body.data < 60 && data.body.data > 0) {
                      this.pb_disabled = true;
                      let time = 60 - data.body.data;
                      this.pb_show = 60 - data.body.data + 1;
                      for (let i = 0; i <= time; i++) {
                        window.setTimeout(() => {
                          --this.pb_show;
                          if (this.pb_show == 0) {
                            this.pb_show = this.$t("message.getVerificationCode");
                            this.pb_disabled = false;
                          }
                        }, i * 1000);
                      }
                    } else {
                      this.$http
                        .post(
                          globalProvider.serviceUrl("ea/tt/c/mrdc"),
                          {
                            mb: this.phoneReg_form.phone,
                            vc: this.phoneReg_form.phone_img_captcha,
                            kv: {
                              考试名称: this.$store.state.examInfo
                                .currentExamInfo.exam_name
                            }
                          },
                          {
                            headers: {
                              ttoken: this.captcha_token
                            },
                            emulateJSON: false
                          }
                        )
                        .then(data => {
                          if (data.body.code == resultCode.Success) {
                            this.set_captcha_token();
                            this.pb_disabled = true;
                            let time = 60;
                            this.pb_show = time + 1;
                            for (let i = 0; i <= time; i++) {
                              window.setTimeout(() => {
                                --this.pb_show;
                                if (this.pb_show == 0) {
                                  this.pb_show = this.$t("message.reSend");
                                  this.pb_disabled = false;
                                  this.captchaUrl =
                                    serviceUrl +
                                    "ea/tt/vc/" +
                                    this.captcha_token; //变回重新发送，同时改变图片验证码
                                }
                              }, i * 1000);
                            }
                          } else if (data.body.code == resultCode.NotSuccess) {
                            this.get_captcha_token();
                            if (data.body.message == "EA_MAA_CDC_01") {
                              /* this.error_display = true;
                                                             this.error_message = getErrorMessage(data.body.message);*/
                            } else {
                              /* this.error_msg = data.body.message;
                                                             this.$refs.phoneReg_form.validateField('phone_img_captcha');*/
                            }
                          } else {
                            this.get_captcha_token();
                          }
                        });
                    }
                  } else if (data.body.code == resultCode.NotSuccess) {
                    /*  this.error_display = true;
                                             this.error_message = getErrorMessage(data.body.message);*/
                  }
                });
            }
          });
        }
      });
    },
    //手机验证
    onPhoneSubmit: function () {
      this.error_display = false;
      this.phoneSubmitDisabled = true;
      this.$refs.phoneReg_form.validateField("phone", valid => {
        if (valid == "") {
          this.$refs.phoneReg_form.validateField("phone_captcha", valid => {
            if (valid == "") {
              this.$http
                .post(
                  globalProvider.serviceUrl("ea/a/mu"),
                  {
                    mb: this.phoneReg_form.phone,
                    dc: this.phoneReg_form.phone_captcha
                  },
                  {
                    headers: {
                      ttoken: this.captcha_token
                    },
                    emulateJSON: false
                  }
                )
                .then(data => {
                  this.phoneSubmitDisabled = false;
                  if (data.body.code == resultCode.Success) {
                    if (data.body.data != null) {
                      this.ttoken = data.body.data;
                      this.$http
                        .get(globalProvider.serviceUrl("pc/g/ctn/{domain}"), {
                          params: {
                            domain: this.$store.state.examInfo.currentExamInfo
                              .domain
                          },
                          headers: {
                            Authorization: "ata-token " + this.ttoken
                          },
                          emulateJSON: false
                        })
                        .then(data => {
                          if (data.body.code == resultCode.Success) {
                            this.$store.commit("setCertType", data.body.data);
                            this.CertTypes = data.body.data;
                          }
                        });
                      this.phoneReg_step = 2;
                    }
                  } else if (data.body.code == resultCode.NotSuccess) {
                    if (data.body.message == "EA_MAA_SUAI_01") {
                      this.error_display = true;
                      this.error_message = getErrorMessage(data.body.message);
                    } else {
                      this.error_msg = data.body.message;
                      this.$refs.phoneReg_form.validateField("phone_captcha");
                    }
                  }
                });
            } else {
              this.phoneSubmitDisabled = false;
            }
          });
        } else {
          this.phoneSubmitDisabled = false;
        }
      });
    },
    //获取邮箱动态码
    onGetEmailCaptcha: function () {
      this.$refs.emailReg_form.validateField("email", valid => {
        if (valid == "") {
          this.$refs.emailReg_form.validateField("email_img_captcha", valid => {
            if (valid == "") {
              this.$http
                .get(globalProvider.serviceUrl("ea/tt/g/erdc/ts/{email}"), {
                  params: { email: this.emailReg_form.email },
                  headers: {
                    ttoken: this.captcha_token
                  }
                })
                .then(data => {
                  if (data.body.code == resultCode.Success) {
                    if (data.body.data < 60 && data.body.data > 0) {
                      this.email_pb_disabled = true;
                      let time = 60 - data.body.data;
                      this.email_pb_show = 60 - data.body.data + 1;
                      for (let i = 0; i <= time; i++) {
                        window.setTimeout(() => {
                          --this.email_pb_show;
                          if (this.email_pb_show == 0) {
                            this.email_pb_show = this.$t("message.getVerificationCode");
                            this.email_pb_disabled = false;
                          }
                        }, i * 1000);
                      }
                    } else {
                      this.$http
                        .post(
                          globalProvider.serviceUrl("ea/tt/c/erdc"),
                          {
                            mb: this.emailReg_form.email,
                            vc: this.emailReg_form.email_img_captcha
                          },
                          {
                            headers: {
                              ttoken: this.captcha_token
                            },
                            emulateJSON: false
                          }
                        )
                        .then(data => {
                          if (data.body.code == resultCode.Success) {
                            this.set_captcha_token();
                            this.email_pb_disabled = true;
                            let time = 60;
                            this.email_pb_show = time + 1;
                            for (let i = 0; i <= time; i++) {
                              window.setTimeout(() => {
                                --this.email_pb_show;
                                if (this.email_pb_show == 0) {
                                  this.email_pb_show = this.$t("message.reSend");
                                  this.email_pb_disabled = false;
                                  this.captchaUrl =
                                    serviceUrl +
                                    "ea/tt/vc/" +
                                    this.captcha_token;
                                }
                              }, i * 1000);
                            }
                          } else if (data.body.code == resultCode.NotSuccess) {
                            this.get_captcha_token();
                            if (data.body.message == "EA_EAA_CDC_01") {
                              this.error_display = true;
                              this.error_message = getErrorMessage(
                                data.body.message
                              );
                            } else {
                              this.error_msg = data.body.message;
                              this.$refs.emailReg_form.validateField("captcha");
                            }
                          } else {
                            this.get_captcha_token();
                          }
                        });
                    }
                  } else if (data.body.code == resultCode.NotSuccess) {
                    this.error_display = true;
                    this.error_message = getErrorMessage(data.body.message);
                  }
                });
            }
          });
        }
      });
    },
    //邮箱验证
    onEmailSubmit: function () {
      this.error_display = false;
      this.emailSubmitDisabled = true;
      this.$refs.emailReg_form.validateField("email", valid => {
        if (valid == "") {
          this.$refs.emailReg_form.validateField("email_captcha", valid => {
            if (valid == "") {
              this.$http
                .post(
                  globalProvider.serviceUrl("ea/a/eu"),
                  {
                    mb: this.emailReg_form.email,
                    dc: this.emailReg_form.email_captcha
                  },
                  {
                    headers: {
                      ttoken: this.captcha_token
                    },
                    emulateJSON: false
                  }
                )
                .then(data => {
                  this.emailSubmitDisabled = false;
                  if (data.body.code == resultCode.Success) {
                    if (data.body.data != null) {
                      this.ttoken = data.body.data;
                      this.$http
                        .get(globalProvider.serviceUrl("pc/g/ctn/{domain}"), {
                          params: {
                            domain: this.$store.state.examInfo.currentExamInfo
                              .domain
                          },
                          headers: {
                            Authorization: "ata-token " + this.ttoken
                          },
                          emulateJSON: false
                        })
                        .then(data => {
                          if (data.body.code == resultCode.Success) {
                            this.$store.commit("setCertType", data.body.data);
                            this.CertTypes = data.body.data;
                          }
                        });
                      this.phoneReg_step = 2;
                    }
                  } else if (data.body.code == resultCode.NotSuccess) {
                    if (data.body.message == "EA_EAA_SUAI_01") {
                      this.error_display = true;
                      this.error_message = getErrorMessage(data.body.message);
                    } else {
                      this.error_msg = data.body.message;
                      this.$refs.emailReg_form.validateField("email_captcha");
                    }
                  }
                });
            } else {
              this.emailSubmitDisabled = false;
            }
          });
        } else {
          this.emailSubmitDisabled = false;
        }
      });
    },
    //完善个人信息
    input_userInform(formName) {
      this.useInfoDisable = true;
      if (this.checked) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.$http
              .post(
                globalProvider.serviceUrl("ea/cmp/uinf"),
                {
                  //                                ac: this.phoneReg_form2.account,
                  pwd: this.phoneReg_form2.pwd,
                  c_pwd: this.phoneReg_form2.c_pwd,
                  name: this.phoneReg_form2.name,
                  ct: this.phoneReg_form2.t_ct,
                  ci: this.phoneReg_form2.ct,
                  group:this.batchCode?"BATCH":"PROJECT"
                },
                {
                  headers: {
                    Authorization: "ata-token " + this.ttoken
                  },
                  emulateJSON: false
                }
              )
              .then(data => {
                this.useInfoDisable = false;
                if (data.body.code == resultCode.Success) {
                  this.phoneReg_step = 3;
                } else if (data.body.code == resultCode.NotSuccess) {
                  this.error_display = true;
                  this.error_message = getErrorMessage(data.body.message);
                }
              });
          } else {
            this.useInfoDisable = false;
            return false;
          }
        });
      } else {
        this.useInfoDisable = false;
        this.error_display = true;
        this.error_message = this.$t("register.agreeManual");
      }
    },
    //返回主页
    back_index: function () {
      this.$store.commit("setToken", this.ttoken);
      this.$router.push({
        name: this.batchCode ? 'batch_main' : 'main',
        params: {
          projectCode: this.$store.state.examInfo.currentExamInfo.domain,
          batchCode: this.batchCode
        },
      })
      // this.$http
      //   .get(globalProvider.serviceUrl("exm_c/g/eis/{domain}"), {
      //     params: {
      //       domain: this.$store.state.examInfo.currentExamInfo.domain
      //     }
      //   })
      //   .then(data => {
      //     if (data.body.code === resultCode.Success) {
      //       this.$router.push({ name: "default.examReg.chooseBatch" });
      //     } else
      //       this.$router.push({
      //         name: this.batchCode ? 'batch_main' : 'main',
      //         params: {
      //           projectCode: this.$store.state.examInfo.currentExamInfo.domain,
      //           batchCode: this.batchCode
      //         },
      //       });
      //   });
    }
  }
};